import { useQuery } from 'react-query';
import queryString from 'query-string';
import { useNamespace, useOkapiKy } from '@folio/stripes/core';

const FACETS_API = 'search/authorities/facets';

export const useFacets = ({
  query,
  selectedFacets = ['sourceFileId'], // We want source file facets
  tenantId,
}) => {
  const ky = useOkapiKy({ tenant: tenantId });
  const [namespace] = useNamespace({ key: 'authority-facets' });

  const searchParams = {
    query: query || 'id=*', // if no filters, return any record to get facets
    facet: selectedFacets.join(','),
  };

  const { isFetching, data } = useQuery(
    [namespace, searchParams],
    async () => {
      const path = `${FACETS_API}?${queryString.stringify(searchParams)}`.replace(/\+/g, '%20');
      return ky.get(path).json();
    },
    {
      keepPreviousData: true,
      // Only fetch facets when we have a meaningful query
      enabled: !!query,
    },
  );

  return {
    facets: data?.facets,
    isLoading: isFetching,
  };
};
